/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentFileTypes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for File Type API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Sunday, December 02, 2018 - 05:56:06 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      12/02/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const FileTypes = {
    all: () => requests.get('/FileTypes'),
    get: filetypeid => requests.get(`/FileType/${filetypeid}`),
    create: filetype => requests.post(`/FileTypes`, filetype),
    update: (filetypeid, filetype) => requests.put(`/FileType/${filetypeid}`, filetype),
    delete: filetypeid => requests.del(`/FileType/${filetypeid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentFileTypes.js